import dayjs from 'dayjs'
import debounce from 'lodash/debounce'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AiOutlineInstagram, AiOutlineYoutube } from 'react-icons/ai'
import { CgFacebook } from 'react-icons/cg'
import { FaLinkedinIn } from 'react-icons/fa'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import api from '../../api'
import Responsive from '../../assets/config/Responsive'
import FraniWhiteEnLogo from '../../assets/icons/JSX/Logo'
import FraniWhiteGeLogo from '../../assets/icons/JSX/LogoGe'
import SmallArrow from '../../assets/icons/JSX/SmallArrow'
import Colors from '../../assets/styles/Colors'
import { Container } from '../../assets/styles/GlobalStyle'
import Loader from '../../components/Loader'
import { useAppSelector } from '../../store'
//
// @ts-ignore
import gita from '../../assets/v2/png/gita.png'
// @ts-ignore
import investGeorgia from '../../assets/v2/png/invest-in-georgia.png'
// @ts-ignore
import mastercard from '../../assets/v2/png/mastercard.png'
// @ts-ignore
import startaperi from '../../assets/v2/png/startaperi.png'
import YouTubeIcon from '../../assets/icons/JSX/YouTubeIcon'
import { AppState } from '../../store/appSlice'

//
//
const Footer = () => {
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  const { t } = useTranslation()
  const [selectedAccordion, setSelectedAccordion] = useState<null | number>(null)
  //
  const location = useLocation()
  //
  const pathName =
    location.pathname === '/business'
      ? '/business'
      : location.pathname === '/business-category'
      ? '/business-category'
      : ''
  //

  const toggleAccordion = (i: number) => {
    if (selectedAccordion === i) {
      return setSelectedAccordion(null)
    }
    setSelectedAccordion(i)
  }
  //
  const { data: footerArray, isLoading: isFooterLoading } = api.useGetWebFooterQuery(undefined)
  //

  // for business landing and business category page
  const businessServicesArray = [
    {
      id: 1,
      title: `${t('healthInsurance')}`,
      url: '/health-company-info',
    },
    {
      id: 2,
      title: `${t('carInsurance')}`,
      url: '/car-company-info',
    },
    {
      id: 3,
      title: `${t('propertyInsurance')}`,
      url: '/property-company-info',
    },
    {
      id: 4,
      title: `${t('otherProducts')}`,
      url: '/other-company-info',
    },
  ]
  //

  const [screenWidth, setScreenWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = debounce(() => setScreenWidth(window.innerWidth), 100)

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  //
  const currentYear = dayjs().year()

  //
  const footerText =
    lang === 'ge'
      ? `სადაზღვევო საბროკერო მომსახურების მიმწოდებელია შპს სადაზღვევო ბროკერი ფრანი, საიდენტიფიკაციო კოდით:
  405454725, მდებარე მისამართზე: ქ. თბილისი, ანა პოლიტკოვსკაიას #3, კორპუსი 37, კომერციული ფართი #3, რომელიც
  სადაზღვევო საბროკერო საქმიანობას ახორციელებს სსიპ საქართველოს დაზღვევის სახელმწიფო ზედამხედველობის
  სამსახურის მიერ 2022 წლის 13 ოქტომბერს მინიჭებული #012056 რეგისტრაციის საფუძველზე.`
      : `The provider of insurance brokerage services is Insurance Broker Frani LLC, VAT: 405454725, located at the address: #3, Anna Politkovskaya, building 37, commercial space #3, Tbilisi, Georgia, that carries out insurance brokerage activities based on registration number N012056 granted on October 13, 2022 by the LEPL Insurance State Supervision Service of Georgia.`
  //
  //
  const currentDomain = window.location.hostname
  //
  //
  return isFooterLoading ? (
    <Loader />
  ) : (
    <>
      <FooterTag>
        <Container>
          <PartnerCompanySection>
            <span className="frani-icon">
              {lang === 'ge' ? <LogoGeStyle /> : lang === 'en' ? <LogoStyle /> : <LogoStyle />}
            </span>
            <PartnerIconsBlock>
              <span>{t('subbortedBy')}: </span>
              <PartnerIconsDiv>
                <a href="https://www.mastercard.com.ge/ka-ge.html" target="_blank" rel="noreferrer">
                  <img src={mastercard} alt="mastercard" />
                </a>

                <a href="https://www.investingeorgia.org/en/" target="_blank" rel="noreferrer">
                  <img src={investGeorgia} alt="investGeorgia" />
                </a>

                <a href="https://www.startuperi.ge/ka/" target="_blank" rel="noreferrer">
                  <img src={startaperi} alt="startaperi" />
                </a>

                <a href="https://gita.gov.ge/" target="_blank" rel="noreferrer">
                  <img src={gita} alt="gita" />
                </a>
              </PartnerIconsDiv>
            </PartnerIconsBlock>
          </PartnerCompanySection>
        </Container>

        <Container>
          <TopSideHR />
        </Container>

        <Container>
          <Wrapper>
            <FooterMainContent>
              <FooterHorizontalSection>
                {/* <CompanyName>myfrani</CompanyName> */}
                {/*  */}
                <FooterDescription>{t('footerLorem')}</FooterDescription>
                {/*  */}
                <SocialIconsWrapper>
                  <a
                    href="https://www.facebook.com/MyFrani"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="facebook-desktop"
                  >
                    <CgFacebook />
                  </a>
                  <a
                    href="https://www.instagram.com/frani_com/"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="instagram-desktop"
                  >
                    <AiOutlineInstagram />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/myfrani"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="linkedin-desktop"
                  >
                    <FaLinkedinIn />
                  </a>
                  <a
                    href="https://www.youtube.com/@Myfrani"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="youtube-desktop"
                  >
                    <YouTubeIcon />
                  </a>
                </SocialIconsWrapper>
                {/*  */}
                <AllRightsReservedText>
                  © {currentYear} {t('allRightReserved')}
                </AllRightsReservedText>
              </FooterHorizontalSection>
              {/*  */}
              {footerArray &&
                footerArray.map((item, index) => {
                  //
                  const tabCount = index + 1
                  //
                  return (
                    <FooterHorizontalSection onClick={() => toggleAccordion(tabCount)} key={index}>
                      <FooterAccordionHead>
                        <TitleText
                          style={{
                            color: Colors.primaryBlack,
                          }}
                        >
                          {item.title?.[lang]?.title}
                        </TitleText>
                        <SmallArrowStyle
                          style={{
                            transform: selectedAccordion === tabCount ? 'rotate(0deg)' : 'rotate(180deg)',
                            fill: selectedAccordion === tabCount ? `${Colors.primaryBlack}` : `${Colors.nevadaGrey}`,
                          }}
                        />
                      </FooterAccordionHead>
                      <FooterHorizontalSectionContent
                        style={{
                          display: screenWidth <= 1199 ? (selectedAccordion === tabCount ? 'flex' : 'none') : 'flex',
                        }}
                      >
                        {location.pathname === pathName && index === 1
                          ? businessServicesArray.map((item) => (
                              <ListItemLink key={item.id} href={item.url} $disabled={false}>
                                {item.title}
                              </ListItemLink>
                            ))
                          : item?.children?.map((subItem, subItemIndex) => (
                              <React.Fragment key={subItemIndex}>
                                {subItem.url === 'hello@frani.com' ? (
                                  <ListItemATag aria-label="email" href={`mailto: ${subItem.url}`}>
                                    {subItem.title?.[lang]?.title}
                                  </ListItemATag>
                                ) : (
                                  <ListItemLink
                                    key={subItem.id}
                                    $disabled={subItem.url === '#' ? true : false}
                                    href={
                                      subItem.url === '/tpl'
                                        ? '/tpl/product-detail'
                                        : subItem.url === '/travel'
                                        ? '/travel/product-detail'
                                        : subItem.url
                                    }
                                  >
                                    {subItem.title?.[lang]?.title}
                                  </ListItemLink>
                                )}
                              </React.Fragment>
                            ))}
                      </FooterHorizontalSectionContent>
                    </FooterHorizontalSection>
                  )
                })}

              <SocialIconsWrapperMobile>
                <a href="https://www.facebook.com/MyFrani" target="_blank" rel="noreferrer" aria-label="facebook">
                  <CgFacebook />
                </a>
                <a href="!#" rel="noreferrer" aria-label="unname">
                  <AiOutlineInstagram />
                </a>
                <a
                  href="https://www.linkedin.com/company/myfrani"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="linkedin"
                >
                  <FaLinkedinIn />
                </a>
                <a href="https://www.youtube.com/@Myfrani" target="_blank" rel="noreferrer" aria-label="youtube">
                  <AiOutlineYoutube />
                </a>
              </SocialIconsWrapperMobile>
              {/*  */}
              <AllRightsReservedTextMobile>
                © {currentYear} {t('allRightReserved')}
              </AllRightsReservedTextMobile>
            </FooterMainContent>
          </Wrapper>

          <div
            style={{
              color: 'transparent',
              display: 'none',
              userSelect: 'none',
              pointerEvents: 'none',
            }}
          >
            <p>
              Შეიძინე სამოგზაურო დაზღვევა ონლაინ 1 ლარად ფრანი-ზე და იმოგზაურე მშვიდად. შეადარე ყველა სადაზღვევო
              კომპანიის პირობა: არდი, ალდაგი, გრინ დაზღვევა, ჯიპიაი, ირაო, პსპ დაზღვევა, ალფა, ბენეფიტს ჯეორჯია, იმედი ლ
              - ერთ სივრცეში სადაზღევვო ბროკერი ფრანი - ს საშუალებით და მიიღე საუკეთესო დაზღვევა ონლაინ. Ერთჯერადი და
              Მრავალჯერადი დაზღვევა ონლაინ. Რა რის ფრანშიზა? თანხის ის ოდენობა, რომელსაც მზღვეველი არ ანაზღაურებს.
              უპირობო ფრანშიზა - თანხა, რომელიც აკლდება ასანაზღაურებელ ოდენობას თითოეული სადაზღვევო შემთხვევის დროს.
              მზღვეველი არ გასცემს სადაზღვევო ანაზღაურებას თუ ზიანი ფრანშიზის ოდენობაზე ნაკლებია; პირობითი ფრანშიზა -
              თანხა, რომლის ფარგლებშიც დამდგარი ზიანი თითოეული სადაზღვევო შემთხვევის დროს არ ანაზღაურდება, თუმცა, თუ
              ზიანმა გადააჭარბა პირობითი ფრანშიზის ოდენობას, მზღვეველი გასცემს სადაზღვევო ანაზღაურებას სრულად.
            </p>
            <p>
              Sheidzine samogzauro dazgveva onlain 1 larad frani-ze da imogzaure mshvidad. Sheadare kvela sadazgvevo
              kompaniis piroba erT sivrceshi: ardi, aldagi, green insurance, GPI, irao, PSP, alfa benefits, imedi L,
              sadazgvevo brokeri frani-s sashualebiT da miige sauketeso dazgveva oნლაინ. Ertjeradi da mravaljeradi
              dazzgveva onlain. Ra aris franshiza? Tanxis is odenoba, romelsac mzgveveli ar anazgaurebs.
            </p>
          </div>
        </Container>
      </FooterTag>
    </>
  )
}

// styles
const PartnerIconsDiv = styled.div`
  display: flex;
  align-items: center;
  margin-left: 50px;
  gap: 24px 32px;
  /*  */
  img {
    height: 48px;
    width: 72px;
    object-fit: contain;
  }

  a {
    text-decoration: none;
  }

  ${Responsive.tablet} {
    width: 100%;
    margin-left: 0px;
  }

  ${Responsive.mobile} {
    margin-left: 0px;
    flex-wrap: wrap;
  }
`
const PartnerIconsBlock = styled.div`
  display: flex;
  align-items: center;
  color: ${Colors.nevadaGrey};
  font-size: 14px;
  line-height: 20px;
  ${Responsive.tablet} {
    align-items: flex-start;
    flex-direction: column;
    width: 100%;

    span {
      margin-bottom: 24px;
    }
  }
  ${Responsive.mobile} {
    align-items: flex-start;
    flex-direction: column;

    span {
      margin-bottom: 24px;
    }
  }
`
const HR = styled.div`
  margin-top: 50px;
  height: 1px;
  width: 100%;
  background-color: ${Colors.grey};

  ${Responsive.tablet} {
    margin-top: 40px;
  }
`
const TopSideHR = styled(HR)`
  margin-top: 60px;
  margin-bottom: 48px;

  ${Responsive.tablet} {
    margin-top: 40px;
    margin-bottom: 32px;
  }
  ${Responsive.mobile} {
    margin-top: 40px;
    margin-bottom: 32px;
  }
`
// const CompanyName = styled.div`
//   font-size: 14px;
//   color: ${Colors.primaryBlack};
//   margin-bottom: 20px;
// `
const CompanyRequisites = styled.p`
  margin-top: 15px;
  color: ${Colors.nevadaGrey};
  text-align: justify;
  font-size: 12px;
  margin-bottom: 0px;
`
const FooterAccordionHead = styled.div`
  ${Responsive.tablet} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    cursor: pointer;
  }
  ${Responsive.mobile} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    cursor: pointer;
  }
`
const SmallArrowStyle = styled(SmallArrow)`
  display: none;
  width: 10px;
  ${Responsive.tablet} {
    display: block;
  }
  ${Responsive.mobile} {
    display: block;
  }
`
const FooterHorizontalSectionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
const AllRightsReservedText = styled.span`
  font-size: 12px;
  color: ${Colors.nevadaGrey};
  ${Responsive.tablet} {
    display: none;
  }
  ${Responsive.mobile} {
    display: none;
  }
`
const AllRightsReservedTextMobile = styled(AllRightsReservedText)`
  display: none;
  ${Responsive.tablet} {
    display: block;
    margin: 0 auto;
  }
  ${Responsive.mobile} {
    display: block;
    margin: 0 auto;
  }
`
const FooterDescription = styled.p`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  line-height: 20px;
  max-width: 340px;
  margin-bottom: 70px;
  ${Responsive.tablet} {
    margin-bottom: 20px;
    font-size: 12px;
  }
  ${Responsive.mobile} {
    margin-bottom: 20px;
    font-size: 12px;
  }
`
const ListItemLink = styled.a<{ $disabled: boolean }>`
  font-size: 14px;
  color: ${({ $disabled }) => ($disabled === true ? Colors.Black : Colors.nevadaGrey)};
  opacity: ${({ $disabled }) => ($disabled === true ? 0.3 : 1)};
  cursor: ${({ $disabled }) => ($disabled === true ? 'default' : 'pointer')};
  padding-top: 5px;
  padding-bottom: 5px;
  margin-top: 3px;
  margin-bottom: 3px;
  text-decoration: none;
  transition: all 200ms ease-in-out;
  &:hover {
    transition: all 100ms ease-in-out;
    color: ${Colors.primaryGrey};
    opacity: ${({ $disabled }) => ($disabled === true ? 0.3 : 0.8)};
  }
  ${Responsive.mobile} {
    padding-top: 2px;
    padding-bottom: 2px;
    margin-top: 1px;
    margin-bottom: 1px;
  }
`
const ListItemATag = styled.a`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  padding-top: 5px;
  padding-bottom: 5px;
  margin-top: 3px;
  margin-bottom: 3px;
  text-decoration: none;
  transition: all 200ms ease-in-out;
  &:hover {
    transition: all 100ms ease-in-out;
    color: ${Colors.primaryGrey};
    opacity: 0.8;
  }
  ${Responsive.mobile} {
    padding-top: 2px;
    padding-bottom: 2px;
    margin-top: 1px;
    margin-bottom: 1px;
  }
`
const TitleText = styled.div`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 18px;
  user-select: none;
  pointer-events: none;
  ${Responsive.tablet} {
    margin-bottom: 0px;
  }
  ${Responsive.mobile} {
    margin-bottom: 0px;
  }
`
const FooterHorizontalSection = styled.div`
  ${Responsive.tablet} {
    user-select: none;
    width: 100%;
    margin-bottom: 10px;
  }
  ${Responsive.mobile} {
    user-select: none;
    width: 100%;
    margin-bottom: 10px;
  }
`
const SocialIconsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 17px;
  a {
    margin-right: 20px;
    svg {
      font-size: 30px;
      transition: all 200ms ease-in-out;
      cursor: pointer;
      color: ${Colors.primaryGrey};
      &:hover {
        transition: all 200ms ease-in-out;
        transform: scale(1.1);
      }
      &:last-child {
        margin-right: 0px;
      }
    }
  }
  ${Responsive.tablet} {
    display: none;
  }
  ${Responsive.mobile} {
    display: none;
  }
`
const SocialIconsWrapperMobile = styled(SocialIconsWrapper)`
  display: none;
  ${Responsive.tablet} {
    display: block;
    margin-top: 30px;
    margin: 30px auto 20px auto;
  }
  ${Responsive.mobile} {
    display: block;
    margin: 30px auto 20px auto;
  }
`

const LogoStyle = styled(FraniWhiteEnLogo)`
  width: 96px;
  fill: ${Colors.white};
  height: 41px;
  ${Responsive.tablet} {
    margin-bottom: 20px;
    width: 60px;
    height: 27px;
  }
  ${Responsive.mobile} {
    margin-bottom: 20px;
    width: 60px;
    height: 26px;
  }
`
const LogoGeStyle = styled(FraniWhiteGeLogo)`
  width: 96px;
  fill: ${Colors.white};
  height: fit-content;
  ${Responsive.tablet} {
    margin-bottom: 20px;
    width: 60px;
  }
  ${Responsive.mobile} {
    margin-bottom: 20px;
    width: 60px;
  }
`
const FooterMainContent = styled.div`
  /* background-color: yellow; */
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  ${Responsive.tablet} {
    flex-direction: column;
  }
  ${Responsive.mobile} {
    flex-direction: column;
  }
`
// const PartnersWrapper = styled.div`
//   background-color: ${Colors.white};
//   padding-block: 70px;
//   /*  */
//   ${Responsive.laptop} {
//     padding-block: 60px;
//   }
//   ${Responsive.tablet} {
//     padding-block: 40px;
//   }
//   ${Responsive.mobile} {
//     padding-block: 30px;
//   }
// `
const PartnerCompanySection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  /* pointer-events: none; */
  /*  */
  svg {
    height: 32px;
  }
  ${Responsive.tablet} {
    justify-content: flex-start;

    .frani-icon {
      svg {
        display: none;
      }
    }
  }
  ${Responsive.mobile} {
    justify-content: flex-start;

    .frani-icon {
      svg {
        display: none;
      }
    }
  }
`
const Wrapper = styled.div``
const FooterTag = styled.footer`
  background-color: ${Colors.lightGrey};
  padding-top: 60px;
  padding-bottom: 90px;
  ${Responsive.tablet} {
    padding-top: 32px;
    padding-bottom: 65px;
  }
  ${Responsive.mobile} {
    padding-top: 32px;
    padding-bottom: 65px;
  }
`

export default Footer
